<template>
  <div class="col-lg-10" style="margin-top: 20px; margin-left: 0;">
    <div class="row row10">
      <div class="col-sm-4">
          <div class="form-group">
            <label>货源模板</label>
            <el-select @change="selectSourceGoodsModel()" v-model="sourceGoodsModel" filterable placeholder="选择货源模板...">
              <el-option v-for="item in sourceGoodsModelList" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
            </el-select>
          </div>
      </div>
    </div>

    <el-form ref="goodForm" size="mini" :model="good" style="margin: 0 -15px;">
      <div class="row">
        <div class="col-sm-10 JY-invoice-title">
          <i>
            <img src="../../assets/images/order-icon-a.png" width="32" height="32" alt>
          </i>设置时间
        </div>
      </div>
      <div class="row row1">
        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="ChuFaRiQi" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">起运日期
                <font class="fn-color-red">*</font>
              </label>
              <el-date-picker :picker-options="pickerOptions" v-model="good.ChuFaRiQi" type="date" placeholder="起运日期"></el-date-picker>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item prop="DaoDaRiQi">
            <div class="form-group">
              <label for="exampleInputEmail1">到达日期</label>
              <el-date-picker :picker-options="pickerOptions" v-model="good.DaoDaRiQi" type="date" placeholder="到达日期"></el-date-picker>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="row row2">
        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="YouXiaoQiStart" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">报价有效期起
                <font class="fn-color-red">*</font>
              </label>
              <el-date-picker :picker-options="pickerOptions" v-model="good.YouXiaoQiStart" type="date" placeholder="报价有效期起"></el-date-picker>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="YouXiaoQiEnd" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">至
                <font class="fn-color-red">*</font>
              </label>
              <el-date-picker :picker-options="pickerOptions" v-model="good.YouXiaoQiEnd" type="date" placeholder="报价有效期止"></el-date-picker>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="row row3">
        <div class="col-sm-10 JY-invoice-title">
          <i>
            <img src="../../assets/images/order-icon-b.png" width="32" height="32" alt>
          </i>设置地址
        </div>
      </div>
      <div class="row row4">
        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="ChuFaDiId" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">出发地
                <font class="fn-color-red">*</font>
              </label>
              <el-cascader @change="startPrivinceChange" change-on-select expand-trigger="hover" :options="provinceList" v-model="good.ChuFaDiId"></el-cascader>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="DaoDaDiId" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">到达地
                <font class="fn-color-red">*</font>
              </label>
              <el-cascader @change="endPrivinceChange" change-on-select expand-trigger="hover" :options="provinceList" v-model="good.DaoDaDiId"></el-cascader>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="row row5">
        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="ChuFaDiAddr" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">详细地址
                <font class="fn-color-red">*</font>
              </label>
              <el-input v-model="good.ChuFaDiAddr" placeholder="请输入详细地址"></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="DaoDaDiAddr" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">详细地址
                <font class="fn-color-red">*</font>
              </label>
              <el-input v-model="good.DaoDaDiAddr" placeholder="请输入详细地址"></el-input>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="row row9">
        <div class="col-sm-10 JY-invoice-title">
          <i>
            <img src="../../assets/images/order-icon-d.png" width="32" height="32" alt>
          </i>货物详情
        </div>
      </div>
      <div class="col-sm-8">
          <el-form-item prop="Description" :rules="rules">
            <div class="form-group">
              <label for="exampleInputEmail1">货物描述
                <font class="fn-color-red">*</font>
              </label>
              <el-input v-model="good.Description" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
            </div>
          </el-form-item>
        </div>
      <div class="row row10">
        <div class="col-sm-4">
          <el-form-item prop="IsDanger" :rules="rules">
            <div class="form-group">
              <label for="exampleInputEmail1">确认所托运货物非危险品
                <font class="fn-color-red">*</font>
              </label>
              <br>
              <el-checkbox v-model="good.IsDanger">非危险品</el-checkbox>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item prop="DataType" :rules="rules">
            <div class="form-group">
              <label for="exampleInputEmail1">货源类型
                <font class="fn-color-red">*</font>
              </label>
              <br>
              <el-select v-model="good.DataType" filterable placeholder="货源类型">
                <el-option key=1 label="提货" value=1></el-option>
                <el-option key=2 label="询价" value=2></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="row row6">

        <div class="col-sm-4">
          <el-form-item :rules="rules" prop="BaoJiaLeiXing">
            <div class="form-group">
              <label for>报价方式
                <font class="fn-color-red">*</font>
              </label>
              <br>
              <el-select v-model="good.BaoJiaLeiXing" filterable placeholder="报价方式">
                <el-option v-for="item in baoJiaLeiXing" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-4">
          <el-form-item prop="YeWuDanHao">
            <div class="form-group">
              <label for>业务编号
              </label>
              <br>
              <el-input placeholder="业务编号" v-model="good.YeWuDanHao"></el-input>
            </div>
          </el-form-item>
        </div>


        <div v-if="good.BaoJiaLeiXing=='0'" class="col-sm-8">
          <el-form-item>
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">货物名称、件数
                <font class="fn-color-red">*</font>
              </label>
              <el-form size="mini" ref="SourceGoodsList" class="dynamic-form">
                <el-form-item v-for="(goodDetail, index) in good.SourceGoodsList" :label="'货物' + (index+1)" :key="goodDetail.key" style="margin-bottom: 14px;">
                  <el-input placeholder="名称" v-model="goodDetail.WuPinName"></el-input>
                  <el-input type="number" v-model="goodDetail.WuPinNumber"></el-input>
                  <el-button type="danger" icon="el-icon-delete" circle @click.prevent="removeGoodDetail(goodDetail)"></el-button>
                </el-form-item>
                <el-form-item style="margin-top: 14px;">
                  <el-button type="primary" @click="addGoodDetail()">新增</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-form-item>
        </div>
        <div v-if="(good.Status == '0' || good.Status == '2') && good.BaoJiaLeiXing=='1'" class="col-sm-8">
          <el-form-item>
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">车辆清单(车型，车数) 
                
              </label>
              <el-form size="mini" ref="CarList" class="dynamic-form">
                <el-form-item v-for="(catItem, index) in good.CarList" :label="'车辆' + (index+1)" :key="catItem.key" style="margin-bottom: 14px;">
                  <el-select v-model="catItem.CarModelID" filterable placeholder="请选择车型..." class="col-sm-4">
                    <el-option v-for="item in carModels" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                  </el-select>
                  <el-input type="number" v-model="catItem.CarNum"></el-input>
                  <el-button type="danger" icon="el-icon-delete" circle @click.prevent="removeCarList(catItem)"></el-button>
                </el-form-item>
                <el-form-item style="margin-top: 14px;">
                  <el-button type="primary" @click="addCarList()">新增</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-8">
          <el-form-item prop="GoodsTypeID" :rules="rules" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">货物类型
                <font class="fn-color-red">*</font>
              </label>
              <el-select v-model="good.GoodsTypeID" filterable placeholder="选择货物类型">
                <el-option v-for="item in goodTypes" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item prop="CargoTypeClassificationCodeTJ" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">货物类型(天津)
              </label>
              <el-select v-model="good.CargoTypeClassificationCodeTJ" filterable placeholder="选择货物类型">
                <el-option v-for="item in goodTypesTJ" :key="item.Code" :label="item.Value" :value="item.Code"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item :rules="rules" prop="GoodsClassID">
            <div class="form-group">
              <label for="exampleInputEmail1">货物分类
                <font class="fn-color-red">*</font>
              </label>
              <el-select v-model="good.GoodsClassID" filterable placeholder="货物分类">
                <el-option v-for="item in goodClassTypes" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div v-if="good.BaoJiaLeiXing=='0'" class="col-sm-8">
          <el-form-item :rules="rules" prop="HuoWuZhongLiang" :show-message="false">
            <div class="form-group">
              <label for="exampleInputEmail1">货物重量（吨）
                <font class="fn-color-red">*</font>
              </label>
              <br/>
              <el-input type="number" v-model="good.HuoWuZhongLiang" placeholder="请输入发货重量"></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-8">
          <el-form-item prop="PackingMethodID" :rules="rules">
            <div class="form-group">
              <label for="exampleInputEmail1">包装方式
                  <font class="fn-color-red">*</font>
              </label>
              <el-select v-model="good.PackingMethodID" filterable placeholder="包装方式">
                <el-option v-for="item in packingMethods" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div v-if="good.BaoJiaLeiXing=='0'" class="col-sm-8">
            <el-form-item :rules="rules" prop="DanBaoZhongLiang" :show-message="false">
                <div class="form-group">
                <label for="exampleInputEmail1">单件重量(公斤)
                    <font class="fn-color-red">*</font>
                </label>
                <br/>
                <el-input type="number" v-model="good.DanBaoZhongLiang" placeholder="单件重量(公斤)"></el-input>
                </div>
            </el-form-item>
        </div>
        <div v-if="good.BaoJiaLeiXing=='1'" class="col-sm-8">
          <el-form-item prop="ZuiDaJianZhongLiang">
              <div class="form-group">
              <label for="exampleInputEmail1">最大单件重量(公斤)</label>
              <el-input type="number" v-model="good.ZuiDaJianZhongLiang" placeholder="最大单件重量(公斤)"></el-input>
              </div>
          </el-form-item>
        </div>
        <div v-if="good.BaoJiaLeiXing=='0'" class="col-sm-8 col-sp">
          <el-form-item>
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">长×宽×高(cm)</label>
              <el-input type="number" @blur="updateTiJi" v-model="good.ZhuangZaiGuiGeLength" placeholder="请输入长"></el-input>×
              <el-input type="number" @blur="updateTiJi" v-model="good.ZhuangZaiGuiGeWidth" placeholder="请输入宽"></el-input>×
              <el-input type="number" @blur="updateTiJi" v-model="good.ZhuangZaiGuiGeHeight" placeholder="请输入高"></el-input>
              <label for="exampleInputEmail1">体积:{{good.TiJi}}cm³</label>
            </div>
          </el-form-item>
        </div>
        <div v-if="good.BaoJiaLeiXing=='1'" class="col-sm-8 col-sp">
          <el-form-item>
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">最大件尺寸 长×宽×高(cm)</label>
              <el-input type="number" v-model="good.ZuiDaJianLength" placeholder="请输入长">0</el-input>×
              <el-input type="number" v-model="good.ZuiDaJianWidth" placeholder="请输入宽">0</el-input>×
              <el-input type="number" v-model="good.ZuiDaJianHeight" placeholder="请输入高">0</el-input>
              <label for="exampleInputEmail1">体积:{{(good.ZuiDaJianLength||0)*(good.ZuiDaJianWidth||0)*(good.ZuiDaJianHeight||0)}}cm³</label>
            </div>
          </el-form-item>
        </div>
        <div v-if="good.BaoJiaLeiXing=='1'" class="col-sm-8">
          <el-form-item prop="DanCheJianShu">
            <div class="form-group">
              <label for="exampleInputEmail1">单车件数</label>
              <el-input type="number" v-model="good.DanCheJianShu" placeholder="单车件数"></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="DanCheZhongLiang">
            <div class="form-group">
              <label for="exampleInputEmail1">单车重量（吨）</label>
              <el-input type="number" v-model="good.DanCheZhongLiang" placeholder="单车重量（吨）"></el-input>
            </div>
          </el-form-item>
        </div>
        <div v-if="good.BaoJiaLeiXing=='0'" class="col-sm-8">
          <el-form-item prop="MaFangFangShi">
            <div class="form-group">
              <label for="exampleInputEmail1">码放方式</label>
              <el-select v-model="good.MaFangFangShi" filterable placeholder="码放方式">
                <el-option v-for="item in maFangTypes" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div v-else class="col-sm-8">
          <el-form-item>
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">
                货源清单
                <a @click="downloadExcel" href="javascript:;">下载货源清单模板</a>
              </label>
              <el-upload class="upload-file-list" 
                accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                :data="{type:'分车Excel'}" 
                :on-change="uploadChange" 
                :http-request="uploadFile" 
                :on-remove="uploadRemove" 
                :limit="1"
                :action="uploadUrl" :file-list="goodListAttachment">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传Excel文件</div>
              </el-upload>
            </div>
          </el-form-item>
        </div>
        
        <div class="col-sm-8">
          <el-form-item>
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">货物图片(近照)</label>
              <el-upload class="upload-file-card" :data="{type:'货物图片(近照)'}" :on-change="uploadChange" :file-list="uploadImages" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="form-group">
              <label for="exampleInputEmail1" style="display: block;">货物图片(远照)</label>
              <el-upload class="upload-file-card" :data="{type:'货物图片(远照)'}" :on-change="uploadChange" :file-list="uploadImages1" :http-request="uploadFile" accept="image/*" :on-remove="uploadRemove" :limit="6" multiple :action="uploadUrl" list-type="picture-card">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
        </div>
        <div class="col-sm-10" style="height: 2px; display: inline-block; background-color: #ddd;"></div>
      </div>
      <div class="row row11">
        <div class="col-sm-10 JY-infor">
          <div style="width: 47%; display: inline-block; margin-right: 16px;">
            <h2>
              发货人资料（
              <font class="fn-color-red">必填</font>）
            </h2>
            <ul>
              <li>
                <i>
                  <img src="../../assets/images/user-head.png" width="24" height="24" alt>
                </i>
                <input type="text" v-model="good.FaHuoRen" class="form-control input-sm" placeholder="发货人姓名">
              </li>
              <li>
                <i>
                  <img src="../../assets/images/user-phone.png" width="24" height="24" alt>
                </i>
                <input type="text" v-model="good.FaHuoRenPhone" class="form-control input-sm" placeholder="发货人手机">
              </li>
              <li style="margin-bottom: 20px;">
                <i>
                  <img src="../../assets/images/user-mail.png" width="24" height="24" alt>
                </i>
                <input type="text" v-model="good.FaHuoRenEmail" class="form-control input-sm" placeholder="发货人邮箱(选填)">
              </li>
              <li style="margin-bottom: 20px;">
                <i>
                  <img src="../../assets/images/user-mail.png" width="24" height="24" alt>
                </i>
                <input type="text" v-model="good.FaHuoRenIDCard" class="form-control input-sm" placeholder="发货人身份证">
              </li>
            </ul>
          </div>
          <div style="float: right; width: 50%;">
            <h2>
              收货人资料（
              <font class="fn-color-red">必填</font>）
            </h2>
            <ul>
              <li>
                <i>
                  <img src="../../assets/images/user-head.png" width="24" height="24" alt>
                </i>
                <input type="text" v-model="good.ShouHuoRen" class="form-control input-sm" placeholder="收货人姓名">
              </li>
              <li>
                <i>
                  <img src="../../assets/images/user-phone.png" width="24" height="24" alt>
                </i>
                <input type="text" v-model="good.ShouHuoRenPhone" class="form-control input-sm" placeholder="收货人手机">
              </li>
              <li style="margin-bottom: 20px;">
                <i>
                  <img src="../../assets/images/user-mail.png" width="24" height="24" alt>
                </i>
                <input type="text" v-model="good.ShouHuoRenEmail" class="form-control input-sm" placeholder="收货人邮箱(选填)">
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row row12">
        <div class="col-sm-10 JY-infor JY-other">
          <h2>其他需求</h2>
          <div>
            <ul>
              <li>
                <el-input v-model="good.QiTa" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
              </li>
              <div style="padding: 10px 0;">
                <el-checkbox v-model="good.KePinChe" style="display:none;">可拼车运输</el-checkbox>
                <el-checkbox v-model="good.HaiGuanJianGuan">需海关监管资质</el-checkbox>
                <el-checkbox v-model="good.TiGongFaPiao" style="display:none;">需要增值税发票</el-checkbox>
              </div>
            </ul>
          </div>
        </div>
        <div class="col-sm-10 text-center" style="padding: 20px 0;">
          <el-checkbox v-model="good.AgreeDelegate">同意</el-checkbox>
          <a href="javascript:;" @click="openCondition2('2cdcb30f-e422-46e0-856e-30840b752ec4','委托协议')">《委托协议》</a>
          <el-checkbox v-model="good.AgreePay">同意</el-checkbox>
          <a href="javascript:;" @click="openCondition('309f8a3a-e00d-4a3a-b1a7-64f0296b3b4a','支付协议')">《支付协议》</a>
        </div>
        <div class="col-sm-10 text-center" style="padding: 20px 0;">
          <button @click="submitForm" :disabled="!(good.AgreePay&&good.AgreeDelegate)" type="button" class="btn btn-danger" style=" display: inline;">提交订单</button>
        </div>
      </div>
    </el-form>
    <el-dialog :title="termName" :visible.sync="conditionDialogVisible" width="70%" center>
      <condition :id="conditionId"></condition>
    </el-dialog>
    <el-dialog :title="termName" :visible.sync="conditionDialogVisible2" width="70%" center>
      <condition :id="conditionId2"></condition>
    </el-dialog>
  </div>
</template>

<script>
  import area from "../../libs/area";
  import util from "../../libs/util";
  import axios from "../../libs/axios";
  import api from "../../api";
  import condition from "../../components/condition";
  export default {
    components: {
      condition
    },
    data() {
      return {
        IDReg: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^((1[1-5])|(2[1-3])|(3[1-7])|(4[1-6])|(5[0-4])|(6[1-5])|71|(8[12])|91)\d{4}((19\d{2}(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(19\d{2}(0[13578]|1[02])31)|(19\d{2}02(0[1-9]|1\d|2[0-8]))|(19([13579][26]|[2468][048]|0[48])0229))((\d{4})|\d{3}[Xx])$)$/,
        conditionDialogVisible: false,
        conditionId: "",
        conditionDialogVisible2: false,
        conditionId2: "",
        termName: "",
        uploadUrl: process.env.BASE_API+'/Apps/JYJYManage/ClientApi/UploadFile',
        uploadImages: [],
        uploadImages1: [],
        goodListAttachment: [],
        good: {
          ChuFaRiQi: "",
          DaoDaRiQi: null,
          YouXiaoQiStart: null,
          YouXiaoQiEnd: null,
          ChuFaDi: null,
          ChuFaDiAddr: null,
          DaoDaDi: null,
          DaoDaDiAddr: null,
          GoodsTypeID: null,
          CargoTypeClassificationCodeTJ: null,
          ZhuangZaiGuiGeLength: 0,
          ZhuangZaiGuiGeWidth: 0,
          ZhuangZaiGuiGeHeight: 0,
          ZuiDaJianLength: null,
          ZuiDaJianWidth: null,
          ZuiDaJianHeight: null,
          FaHuoRen: null,
          FaHuoRenPhone: null,
          FaHuoRenEmail: null,
          FaHuoRenIDCard: null,
          ShouHuoRen: null,
          ShouHuoRenPhone: null,
          QiTa: null,
          KePinChe: 0,
          HaiGuanJianGuan: 0,
          TiGongFaPiao: 0,
          Description: null,
          DanCheJianShu: null,
          DanCheZhongLiang: null,
          ZuiDaJianZhongLiang: null,
          BaoJiaLeiXing: 0,
          CarList: [],
          ShouHuoRenEmail: null,
          GoodsClassID: null,
          PackingMethodID: null,
          DataType: null,
          HuoWuZhongLiang: null,
          SourceGoodsList: [],
          MaFangFangShi: null,
          DanBaoZhongLiang: null,
          Status: 0,
          ChuFaDiId:"",
          DaoDaDiId:"",
          IsDanger: true,
        },
        provinceList: area.provinceList,
        carModels: [],
        carStructures: [],
        goodTypes: [],
        goodTypesTJ: [],
        goodClassTypes: [],
        paymentTypes: [],
        packingMethods: [],
        sourceGoodsModel: null,
        sourceGoodsModelList: [],
        maFangTypes: [{ ID: 0,Name: "立放"},{ID: 1,Name: "叠放"}],
        rules: [{
          required: true,
          message: "必填",
          trigger: "blur"
        }],
        baoJiaLeiXing: [{ID: 0,Name: "按吨"},{ID: 1,Name: "按车"}],
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        }
      };
    },
    methods: {
      updateTiJi() {
        let tiji =(this.good.ZhuangZaiGuiGeLength || 0)*(this.good.ZhuangZaiGuiGeWidth || 0)*(this.good.ZhuangZaiGuiGeHeight || 0);
        this.$set(this.good, "TiJi", tiji);
      },
      openCondition(id, name) {
        this.conditionId = id;
        this.termName = name;
        this.conditionDialogVisible = true;
      },
      openCondition2(id, name) {
        this.conditionId2 = id;
        this.termName = name;
        this.conditionDialogVisible2 = true;
      },
      addCarList() {
        if(this.good.CarList==null){
            this.good.CarList=[]
        }
        this.good.CarList.push({
          key: this.good.CarList.length,
          CarModelID: "",
          CarStructID: "",
          CarNum: 0
        });
      },
      removeCarList(item) {
        var index = this.good.CarList.indexOf(item);
        if (index !== -1) {
          this.good.CarList.splice(index, 1);
        }
      },
      addGoodDetail() {
        this.good.SourceGoodsList.push({
          key: this.good.SourceGoodsList.length,
          WuPinName: "",
          WuPinNumber: 0
        });
      },
      getSourceGoodsModelList(){
        let _this = this;
        api.getSourceGoodsModelList().then(res => {
          if (res.data.Succeed) {
            _this.sourceGoodsModelList = res.data.Data;
          }
        });
      },
      selectSourceGoodsModel(){
        for (let index = 0; index < this.sourceGoodsModelList.length; index++) {
          if(this.sourceGoodsModel==this.sourceGoodsModelList[index].ID){
            this.good=JSON.parse(this.sourceGoodsModelList[index].Description)
            this.good.IsDanger=true
            this.good.ChuFaDiId = this.getAreaCode(this.good.ChuFaDi)
            this.good.DaoDaDiId = this.getAreaCode(this.good.DaoDaDi)
            this.good.KePinChe=this.good.KePinChe==1?true:false
            this.good.HaiGuanJianGuan=this.good.HaiGuanJianGuan==1?true:false
            this.good.TiGongFaPiao=this.good.TiGongFaPiao==1?true:false
            if (this.good.YouXiaoQiStart)
              this.good.YouXiaoQiStart =new Date(this.good.YouXiaoQiStart.split('T')[0]) 
            if (this.good.YouXiaoQiEnd)
              this.good.YouXiaoQiEnd =new Date(this.good.YouXiaoQiEnd.split('T')[0])
            if (this.good.ChuFaRiQi)
              this.good.ChuFaRiQi =new Date(this.good.ChuFaRiQi.split('T')[0])
            if (this.good.DaoDaRiQi)
              this.good.DaoDaRiQi =new Date(this.good.DaoDaRiQi.split('T')[0])
            this.good.ID=null
            break
          }
        }
      },
      removeGoodDetail(item) {
        var index = this.good.SourceGoodsList.indexOf(item);
        if (index !== -1) {
          this.good.SourceGoodsList.splice(index, 1);
        }
      },
      removeCarItem(item){
        var index = this.good.CarList.indexOf(item);
        if (index !== -1) {
          this.good.CarList.splice(index, 1);
        }
      },
      uploadFile(f) {
        let param = new FormData();
        param.append("file", f.file);
        param.append("attid", f.file.uid + f.file.size + Math.random());
        param.append("attname", f.file.name);
        param.append("type", f.data.type);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: util.cookies.get("access_token")
          }
        }; //添加请求头
        //上传图片
        axios.post(f.action, param, config).then(response => {
            f.onSuccess(response.data);
          }).catch(err => {
            f.onError(err);
          });
      },
      uploadChange(file, fileList) {
        if (file.response) {
          fileList.forEach(function(item) {
            if (item.name == file.name) {
              item.attid = file.response.id;
              item.type = file.response.type;
              item.url = process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+file.response.id;
            }
          });
          this.updateAtts(file, fileList);
        }
      },
      uploadRemove(file, fileList) {
        this.updateAtts(file, fileList);
      },
      updateAtts(file, fileList) {
        if (file.type == "货物图片(近照)") {
          this.uploadImages = fileList;
        }
        if (file.type == "货物图片(远照)") {
          this.uploadImages1 = fileList;
        } else if (file.type == "分车Excel") {
          this.goodListAttachment = fileList;
        }
      },
      submitForm() {
        let _this = this
        //替换出发地详细地址和到达地详细地址的所有空格
        if(_this.good.ChuFaDiAddr)
          _this.good.ChuFaDiAddr = _this.good.ChuFaDiAddr.replace(/\s+/g,"");

        if(_this.good.DaoDaDiAddr)
          _this.good.DaoDaDiAddr = _this.good.DaoDaDiAddr.replace(/\s+/g,"");

        //验证
        if(_this.good.ChuFaDiId){
          if(_this.good.ChuFaDiId.length != 3){
            _this.$message({
              message: "请输入完整的出发地",
              type: "error"
            });
            return;
          }
        }

        if(_this.good.DaoDaDiId){
          if(_this.good.DaoDaDiId.length != 3){
            _this.$message({
              message: "请输入完整的到达地",
              type: "error"
            });
            return;
          }
        }

        if (_this.good.FaHuoRenPhone) {
          let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/
          if (!reg.test(_this.good.FaHuoRenPhone)) {
            _this.$message({
              message: "发货人手机号不正确",
              type: "error"
            });
            return;
          }
        }
        if (_this.good.ShouHuoRenPhone) {
          let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/
          if (!reg.test(_this.good.ShouHuoRenPhone)) {
            _this.$message({
              message: "收货人手机号不正确",
              type: "error"
            });
            return;
          }
        }
        if (_this.good.FaHuoRenIDCard) {
          if (!_this.IDReg.test(_this.good.FaHuoRenIDCard)) {
            _this.$message({
              message: "发货人身份证号不正确",
              type: "error"
            });
            return;
          }
        }
        if (_this.good.DaoDaRiQi && _this.good.ChuFaRiQi) {
          let start = util.formatDate(_this.good.ChuFaRiQi, 'yyyy-MM-dd')
          let end = util.formatDate(_this.good.DaoDaRiQi, 'yyyy-MM-dd')
          if (util.compareDate(start, end)) {
            _this.$message({
              message: "起运日期输入不正确",
              type: "error"
            });
            return;
          }
        }
        if (_this.good.YouXiaoQiStart && _this.good.YouXiaoQiEnd) {
          let start = util.formatDate(_this.good.YouXiaoQiStart, 'yyyy-MM-dd')
          let end = util.formatDate(_this.good.YouXiaoQiEnd, 'yyyy-MM-dd')
          if (util.compareDate(start, end)) {
            _this.$message({
              message: "报价有效期输入不正确",
              type: "error"
            });
            return;
          }
        }
        if (_this.good.YouXiaoQiStart && _this.good.ChuFaRiQi) {
          let start = util.formatDate(_this.good.YouXiaoQiStart, 'yyyy-MM-dd')
          let end = util.formatDate(_this.good.ChuFaRiQi, 'yyyy-MM-dd')
          if (util.compareDate(start, end) || start == end) {
            _this.$message({
              message: "报价有效期应大于起运日期至少1天",
              type: "error"
            });
            return;
          }
        }
        if (!_this.good.FaHuoRen || !_this.good.FaHuoRenPhone) {
          _this.$message({
            message: "发货人信息填写不正确",
            type: "error"
          });
          return;
        }
        if (!_this.good.ShouHuoRen || !_this.good.ShouHuoRenPhone) {
          _this.$message({
            message: "收货人信息填写不正确",
            type: "error"
          });
          return;
        }
        if (!_this.good.IsDanger) {
          _this.$message({
            message: "请确认所托运货物非危险品",
            type: "error"
          });
          window.scrollTo(0, 600);
          return;
        }
        if (_this.good.BaoJiaLeiXing == "0") {
          if (_this.good.SourceGoodsList.length == 0) {
            _this.$message({
              message: "请填写货物清单",
              type: "error"
            });
            return;
          }
        } 
        // else {
        //   if (_this.goodListAttachment.length == 0) {
        //     _this.$message({
        //       message: "请上传货物清单",
        //       type: "error"
        //     });
        //     return;
        //   }
        // }
        _this.$refs["goodForm"].validate(valid => {
          if (valid) {
            _this.createSourceGoods();
          } else {
            window.scrollTo(0, 0);
            _this.$message({
              message: "货源信息填写有误,请仔细检查。",
              type: "error"
            });
            return false;
          }
        });
      },
      createSourceGoods() {
        let _this = this;
        let attachments = [];
        _this.uploadImages.forEach(item => {
          attachments.push({
            id: item.attid,
            type: "货物图片(近照)"
          });
        });
        _this.uploadImages1.forEach(item => {
          attachments.push({
            id: item.attid,
            type: "货物图片(远照)"
          });
        });
        _this.goodListAttachment.forEach(item => {
          attachments.push({
            id: item.attid,
            type: "分车Excel"
          });
        });
        const loading = _this.$loading({
          lock: true,
          text: "正在保存...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        api.createSourceGoods({
            model: _this.good,
            attachments: JSON.stringify(attachments)
          }).then(res => {
            loading.close();
            if (res.data.Succeed) {
              window.scrollTo(0, 0);
              _this.$message({
                message: "保存成功",
                type: "success"
              });
              _this.good = {};
              _this.uploadImages = [];
              _this.uploadImages1 = [];
              document.getElementById("shipper-goods").click();
              _this.$router.push("/shipper/goods");
            } else {
              _this.$message({
                message: res.data.Message,
                type: "error"
              });
            }
          });
      },
      getDictionaries() {
        let _this = this;
        api.getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "carModel"
          }).then(res => {
            _this.carModels = res.data.Data.Data;
          });
        api.getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "carStruct"
          })
          .then(res => {
            _this.carStructures = res.data.Data.Data;
          });
        api.getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "goodsType"
          }).then(res => {
            _this.goodTypes = res.data.Data.Data;
          });
        //  httpService.post("/Apps/JYJYManage/Dict/DictSearch", 
        //  tableName: 'CargoType'             Dict/DictSearch
         api.getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "CargoType"
          }).then(res => {
            _this.goodTypesTJ = res.data.Data.Data;
          });
        api.getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "payment"
          }).then(res => {
            _this.paymentTypes = res.data.Data.Data;
          });
        api.getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "goodsClass"
          }).then(res => {
            _this.goodClassTypes = res.data.Data.Data;
          });
        api.getDictionary({
            search: {
              IsEnabled: "",
              PageNo: 1,
              PageSize: 1000
            },
            tableName: "packingMethod"
          }).then(res => {
            _this.packingMethods = res.data.Data.Data;
          });
      },
      startPrivinceChange() {
        var arr = this.getCascaderObj(this.good.ChuFaDiId, this.provinceList);
        var str = [];
        arr.forEach(item => {
          str.push(item.label);
        });
        this.good.ChuFaDi = str.join(",");
      },
      endPrivinceChange() {
        var arr = this.getCascaderObj(this.good.DaoDaDiId, this.provinceList);
        var str = [];
        arr.forEach(item => {
          str.push(item.label);
        });
        this.good.DaoDaDi = str.join(",");
      },
      getCascaderObj(val, opt) {
        return val.map(function(value) {
          for (var itm of opt) {
            if (itm.value == value) {
              opt = itm.children;
              return itm;
            }
          }
          return null;
        });
      },
      downloadExcel() {
        var src = process.env.BASE_API + "/Apps/JYJYManage/Preview/DownloadGoodListTemplate";
        document.getElementById("download_iframe").src = src;
      },
      getAreaCode(addr) {
        var result = [];
        var arr = addr.split(',');
        var p = area.provinceList.filter(d => d.label == arr[0]);
        if (p && p[0]&&arr.length>1) {
          result.push(p[0].value);
          var c = p[0].children.filter(d => d.label == arr[1])
          if (c && c[0]&&arr.length>2) {
            result.push(c[0].value)
            var a = c[0].children.filter(d => d.label == arr[2])
            if (a && a[0]) {
              result.push(a[0].value)
            }
          }
        }
        return result;
      },
      InitSourceGood(id) {
        let _this = this
        api.getSourceGood({id: id}).then(res => {
          if (res.data.Succeed) {
            var d = res.data.Data.Data;
            d.IsDanger = true;
            d.ChuFaDiId = _this.getAreaCode(d.ChuFaDi);
            d.DaoDaDiId = _this.getAreaCode(d.DaoDaDi);
            d.ChuFaRiQi = new Date(res.data.Data.Data.ChuFaRiQi);
            d.DaoDaRiQi = new Date(res.data.Data.Data.DaoDaRiQi);
            d.YouXiaoQiStart = new Date(res.data.Data.Data.YouXiaoQiStart);
            d.YouXiaoQiEnd = new Date(res.data.Data.Data.YouXiaoQiEnd);
            _this.good = d;
            var atts=res.data.Data.Attachments;
            atts.forEach(item=>{
              item.src=''
              if(item.TypeName=='货物图片(近照)'){
                _this.uploadImages.push({
                  attid:item.AttID,
                  type:'货物图片(近照)',
                  url:process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID
                })
              }else if(item.TypeName=='货物图片(远照)'){
                _this.uploadImages1.push({
                  attid:item.AttID,
                  type:'货物图片(远照)',
                  url:process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID
                })
              }else if(item.TypeName=='分车Excel'){
                _this.goodListAttachment.push({
                  attid:item.AttID,
                  type:'分车Excel',
                  name:item.AttName
                })
              }
            })
          }
        })
      },

      CopySourceGood(id) {
        let _this = this
        api.getSourceGood({id: id}).then(res => {
          if (res.data.Succeed) {
            var d = res.data.Data.Data;

            d.ChuFaRiQi = new Date(res.data.Data.Data.ChuFaRiQi);
            d.DaoDaRiQi = new Date(res.data.Data.Data.DaoDaRiQi);
            d.YouXiaoQiStart = new Date(res.data.Data.Data.YouXiaoQiStart);
            d.YouXiaoQiEnd = new Date(res.data.Data.Data.YouXiaoQiEnd);

            _this.good.IsDanger = true;
            _this.good.ChuFaRiQi=d.ChuFaRiQi
            _this.good.DaoDaRiQi=d.DaoDaRiQi
            _this.good.YouXiaoQiStart=d.YouXiaoQiStart
            _this.good.YouXiaoQiEnd=d.YouXiaoQiEnd
            _this.good.ChuFaDi=d.ChuFaDi
            _this.good.ChuFaDiId=_this.getAreaCode(d.ChuFaDi)
            _this.good.ChuFaDiAddr=d.ChuFaDiAddr
            _this.good.DaoDaDi=d.DaoDaDi
            _this.good.DaoDaDiId=_this.getAreaCode(d.DaoDaDi)
            _this.good.DaoDaDiAddr=d.DaoDaDiAddr
            _this.good.GoodsTypeID=d.GoodsTypeID
            _this.good.CargoTypeClassificationCodeTJ=d.CargoTypeClassificationCodeTJ
            _this.good.ZhuangZaiGuiGeLength=d.ZhuangZaiGuiGeLength
            _this.good.ZhuangZaiGuiGeWidth=d.ZhuangZaiGuiGeWidth
            _this.good.ZhuangZaiGuiGeHeight=d.ZhuangZaiGuiGeHeight
            _this.good.ZuiDaJianLength=d.ZuiDaJianLength
            _this.good.ZuiDaJianWidth=d.ZuiDaJianWidth
            _this.good.ZuiDaJianHeight=d.ZuiDaJianHeight
            _this.good.FaHuoRen=d.FaHuoRen
            _this.good.FaHuoRenPhone=d.FaHuoRenPhone
            _this.good.FaHuoRenEmail=d.FaHuoRenEmail
            _this.good.FaHuoRenIDCard=d.FaHuoRenIDCard
            _this.good.ShouHuoRen=d.ShouHuoRen
            _this.good.ShouHuoRenPhone=d.ShouHuoRenPhone
            _this.good.QiTa=d.QiTa
            _this.good.KePinChe=d.KePinChe
            _this.good.HaiGuanJianGuan=d.HaiGuanJianGuan
            _this.good.TiGongFaPiao=d.TiGongFaPiao
            _this.good.Description=d.Description
            _this.good.DanCheJianShu=d.DanCheJianShu
            _this.good.DanCheZhongLiang=d.DanCheZhongLiang
            _this.good.ZuiDaJianZhongLiang=d.ZuiDaJianZhongLiang
            _this.good.BaoJiaLeiXing=d.BaoJiaLeiXing
            _this.good.CarList=d.CarList
            _this.good.ShouHuoRenEmail=d.ShouHuoRenEmail
            _this.good.GoodsClassID=d.GoodsClassID
            _this.good.PackingMethodID=d.PackingMethodID
            _this.good.DataType=d.DataType
            _this.good.HuoWuZhongLiang=d.HuoWuZhongLiang
            _this.good.SourceGoodsList=d.SourceGoodsList
            _this.good.MaFangFangShi=d.MaFangFangShi
            _this.good.DanBaoZhongLiang=d.DanBaoZhongLiang

          }
        })
      }

    },
    mounted() {
      this.addGoodDetail();
      this.addCarList();
      this.getDictionaries();
      this.getSourceGoodsModelList();
      if (this.$route.query.id) {
        this.InitSourceGood(this.$route.query.id)
      }
      if (this.$route.query.copyid) {
        this.CopySourceGood(this.$route.query.copyid)
      }
    }
  };
</script>

<style scoped>
  .el-date-editor {
    width: 284px !important;
  }
  .row4 .el-select {
    width: 32%;
    margin-left: 3px;
  }
  .row6 .el-input {
    width: 76%;
  }
  .row10 .el-select,
  .col-sm-8 .el-select,
  .el-cascader {
    width: 100%;
  }
  .col-sp .el-input {
    width: 25%;
  }
  .el-checkbox__inner,
  .JY-other li span {
    padding-right: 0 !important;
  }
  .dynamic-form .el-input {
    width: 35%;
    margin-right: 10px;
  }
  .dynamic-form2 .el-input,
  .dynamic-form2 .el-select {
    width: 160px !important;
    margin-right: 10px;
  }
  .el-upload--picture-card {
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
  }
  .upload-file-card>.el-upload-list__item {
    width: 100% !important;
    height: 100px !important;
  }
  .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: cover;
  }
  .el-checkbox__inner {
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Shipper/ShipperForm.vue